<template>
  <div class="home">
    <van-nav-bar
      :title="viewId ? '查看围栏信息' : '新建围栏信息'"
      left-text="返回"
      left-arrow
      @click-left="$router.go('-1')"
    />
    <van-notice-bar
      left-icon="volume-o"
      text="请在地图上手动选定3个或者3个以上的地理坐标"
    />
    <div id="container" class="container"></div>
    <div class="operat" v-if="!viewId">
      <van-button
        type="primary"
        size="small"
        style="min-width: 80px;"
        @click="showPositionDialog = true"
        round
        >查找地址</van-button
      >
      <van-button
        type="primary"
        size="small"
        style="margin-top: 10px;min-width: 80px;"
        @click="clearRangeForMap"
        round
        >清除</van-button
      >
      <van-button
        type="info"
        size="small"
        style="margin-top: 10px;min-width: 80px;"
        @click="handleAddPosition"
        round
        >提交</van-button
      >
    </div>

    <!-- 提交弹出层 -->
    <van-dialog
      v-model="showDialog"
      title="围栏名称"
      show-cancel-button
      @confirm="handleAddNamePosition"
    >
      <input
        class="dialog-input"
        v-model="name"
        type="text"
        placeholder="请输入围栏名称"
      />
    </van-dialog>

    <!-- 查找位置弹出层 -->
    <van-dialog
      v-model="showPositionDialog"
      title="查找地址"
      show-cancel-button
      @confirm="handleSearchPosition"
    >
      <input
        class="dialog-input"
        v-model="cityName"
        type="text"
        placeholder="请输入地址(地址需唯一，例西湖区骆家庄)"
      />
    </van-dialog>
  </div>
</template>

<script>
import { NavBar, Button, NoticeBar, Dialog, Toast } from 'vant'
export default {
  data() {
    return {
      viewId: null, // 查看坐标id
      cityName: '', // 位置名字
      showPositionDialog: false, //查找位置弹出层
      showDialog: false,
      name: '',
      map: null, // 初始地图
      polygonArr: [],
      // polygonArr: [
      //   {
      //     lat: 30.355325,
      //     lng: 120.12096
      //   },
      //   {
      //     lat: 30.355968,
      //     lng: 120.120418
      //   },
      //   {
      //     lat: 30.356197,
      //     lng: 120.121907
      //   }
      // ], //多边形的各个点坐标
      range_marker: [], //多边形的各个线
      polygon: null, // 画图样式
      want_remove_marker: [], //封装需要清除的点数组

      spotSrc: require('../../assets/images/icon-spot.png')
    }
  },
  mounted() {
    var container = document.getElementById('container')
    // 初始化map
    this.map = new window.AMap.Map('container', {
      resizeEnable: true, // 是否监控地图容器尺寸变化
      zoom: 17 // 初始化地图层级
      // center: [116.397428, 39.90923]
    })
    // console.log(this.polygonArr,'11')
    for (var i = 0; i < this.polygonArr.length; i++) {
      this.makeAMarker(this.polygonArr[i].lat, this.polygonArr[i].lng)
    }

    // 获取是否查看围栏/id
    this.viewId = this.$route.query.viewId
    if (this.viewId) {
      var sinfo = localStorage.getItem("currentFence");
      var weilan = JSON.parse(sinfo);
      var datalist = [];
      var addlist = weilan.Addrlist.split(";")
     
      for(var i=0;i<addlist.length;i++){
        if(addlist[i]=="")continue;
        var vlist = addlist[i].split(",");
        
        var d = {
          lng:vlist[0],
          lat:vlist[1],
        }
        datalist.push(d);
      }
     
      this.polygonArr = datalist;
      
      for (var i = 0; i < this.polygonArr.length; i++) {
       
        this.makeAMarker(this.polygonArr[i].lat, this.polygonArr[i].lng)
      }
          
    } else {
      //为地图注册click事件获取鼠标点击出的经纬度坐标
      var clickEventListener = this.map.on('click', e => {
        this.polygonArr.push({ lng: e.lnglat.getLng(), lat: e.lnglat.getLat() })
        this.makeAMarker(e.lnglat.getLat(), e.lnglat.getLng())
        //makeRangeToMap();
      })
    }
  },
  methods: {
    // 查找位置
    handleSearchPosition() {
      if (!this.cityName) {
        Toast('地址不能为空！')
        return
      }

      this.$http
        .get(
          `http://restapi.amap.com/v3/geocode/geo?key=56623b79c1588d5e570e46bed4d84266&s=rsv3&city=35&address=${this.cityName}`
        )
        .then(data => {
          this.cityName = ''
          if (data.geocodes.length > 0) {
            this.clearRangeForMap()
            var cityPosition = data.geocodes[0].location.split(',')
            this.map.setCenter([cityPosition[0], cityPosition[1]])
          } else {
            Toast('一个有效的地址应该是独一无二的哦~')
          }
        })
    },
    handleAddNamePosition() {
      if (!this.name) {
        Toast('名称不能为空！')
        return
      }
      var addrlist ="";
      for (var i=0;i<this.polygonArr.length;i++){
        addrlist += this.polygonArr[i].lng + "," + this.polygonArr[i].lat + ";";
      }
      var sinfo = localStorage.getItem('currentChild');
      var studentinfo = JSON.parse(sinfo);
      this.$http
        .json_post(this.$api.studentcard.addweilaninfo, {
          Deviceid: studentinfo.Deviceid,
          Weilanname: this.name,
          Addrlist: addrlist
        })
        .then(data => {
          if (data.code == 0) {
            Toast('添加成功')
            this.$router.push({ name: 'fence' })
          }else{
            Toast(data.msg)
          }
        })
    },

    handleAddPosition() {
      if (this.polygonArr.length <= 0) {
        Toast('快去绘制一个坐标吧~')
        return
      }
      this.showDialog = true

    },

    //根据坐标数组在地图上话围栏
    //温岚的坐标点数组
    makeAMarker(lat, lng) {
      console.log(lat, lng)
      var amarker = new AMap.Marker({
        position: [lng, lat],
        offset: new AMap.Pixel(-7, -28),
        icon: new AMap.Icon({
          size: new AMap.Size(15, 28), //图标大小
          image: this.spotSrc
        })
      })
      this.map.add(amarker)
      this.range_marker.push(amarker)
      var list = new Array()
      for (var i = 0; i < this.polygonArr.length; i++) {
        list[i] = new Array()
        list[i][0] = this.polygonArr[i].lng
        list[i][1] = this.polygonArr[i].lat
      }
      if (this.polygon) {
        this.map.remove(this.polygon)
      }
      this.polygon = new AMap.Polygon({
        path: list, //设置多边形边界路径
        strokeColor: '#07c160', //线颜色
        strokeOpacity: 1, //线透明度
        strokeWeight: 1, //线宽
        fillColor: '#f3bf33', //填充色
        fillOpacity: 0.35 //填充透明度
      })
      this.map.add(this.polygon)
      this.map.setFitView([this.polygon])
    },

    //移除地图上的所有点个线
    clearRangeForMap() {
      //移除地图上的所有点个线
      this.map.remove(this.range_marker)
      this.range_marker = new Array()
      if (this.polygon) {
        this.map.remove(this.polygon)
      }
      this.polygonArr = new Array()
    },
    handleFence() {
      this.$router.push({ name: 'fence' })
    }
  },
  components: {
    'van-nav-bar': NavBar,
    'van-button': Button,
    'van-notice-bar': NoticeBar,
    [Dialog.Component.name]: Dialog.Component
  }
}
</script>

<style lang="scss" scoped>
.home,
#container {
  width: 100%;
  height: calc(100vh - 50px);
}
.operat {
  position: fixed;
  right: 10px;
  bottom: 40px;
  z-index: 99;
  display: flex;
  flex-direction: column;
  justify-content: center;
  i {
    width: 50px;
    height: 50px;
    font-size: 18px;
    margin-top: 15px;
    line-height: 50px;
    color: #fff;
    text-align: center;
    background: #40e0d0; /* fallback for old browsers */
    background: -webkit-linear-gradient(
      to right,
      #40e0d0,
      #07c160
    ); /* Chrome 10-25, Safari 5.1-6 */
    background: linear-gradient(
      to right,
      #40e0d0,
      #07c160
    ); /* W3C, IE 10+/ Edge, Firefox 16+, Chrome 26+, Opera 12+, Safari 7+ */
    box-shadow: 0 2px 6px rgba(0, 0, 0, 0.4);
    border-radius: 50%;
    &.icon-dingwei1 {
      font-size: 22px;
    }
  }
}
.dialog-input {
  display: block;
  width: 275px;

  height: 0.8rem;
  line-height: 17px;
  font-size: 15px;
  font-weight: 500;
  color: #999;
  text-indent: 5px;
  border: 1px solid #ddd;
  background: none;
  outline: none;
  margin: 0.6rem auto;
}
</style>
